module.exports = __webpack_public_path__ + "media/images/mailer/snapchat-light-5e27281cc5cba02acb12a13b0c1364fa.png";